<template>
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-4">
        <div class="card">
          <CardHeader :data="cardHeader" />
          <slot />
          <CardFooter :data="cardFooter" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CardFooter, CardHeader } from "./components/exporter.js";
export default {
  name: "card-container",
  components: {
    CardFooter,
    CardHeader,
  },
  props: {
    cardHeader: {
      type: Object,
    },
    cardFooter: {
      type: Object,
    },
  },
};
</script>
